import gql from 'graphql-tag'

export default gql`
  mutation updateBalanceSheet(
    $input: UpdateBalanceSheetInput!
    # $balanceSheetId: Int!,
    # $checkingSaving: Float,
    # $fixedAssets: Float,
    # $currentLiabilities: Float,
    # $nonCurrentLiabilities: Float,
    # $cashEquivalents: Float,
    # $balanceSheetDate: Date
  ) {
    updateBalanceSheet(input: $input) {
      balanceSheet {
        rid
      }
    }
  }
`
